export default __webpack_public_path__ + "5c282f99364153cabdf066498773dceb.jpg";